import React, { FunctionComponent } from 'react'

import styled from 'styled-components'

import { Text, baseColors } from '@fairhq/common'
import { InwardsArrows } from 'components/svgs/icons/InwardsArrows'
import { OutwardsArrows } from 'components/svgs/icons/OutwardsArrows'

const Tag = styled.div<{ backgroundColor: string; color: string }>`
  display: inline-flex;
  gap: 2px;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  white-space: nowrap;
  color: ${({ color }) => color};
  width: max-content;
  align-self: center;
`

interface GapTagProps {
  value: number
  displayValue?: string
}

export const GapTag: FunctionComponent<GapTagProps> = ({
  value,
  displayValue,
}) => {
  if (value === 0) {
    return null
  }

  return (
    <Tag
      backgroundColor={
        value > 0
          ? baseColors.backgroundSuccessSurface
          : baseColors.backgroundDangerSurface
      }
      color={value > 0 ? baseColors.contentSuccess : baseColors.contentDanger}
    >
      {value > 0 ? <InwardsArrows /> : <OutwardsArrows />}
      <Text type="body" element="span" size="sm" fontWeight={600}>
        {displayValue ?? Math.round(value)}
      </Text>
    </Tag>
  )
}
